import React from 'react';
import classNames from 'classnames/bind';
import { LuRefreshCcw } from 'react-icons/lu';

import styles from './Account.module.scss';

const cx = classNames.bind(styles);

function AccountHeader({ isRefreshing, onRefresh }) {
    return (
        <header className={cx('account-page__header')}>
            <div>
                <h1>Quản lý tài khoản</h1>
                <p>Theo dõi và quản trị các tài khoản nhân sự không thuộc nhóm quản trị hệ thống.</p>
            </div>
            <button type="button" className={cx('refresh-button')} onClick={onRefresh} disabled={isRefreshing}>
                <LuRefreshCcw /> {isRefreshing ? 'Đang tải...' : 'Làm mới'}
            </button>
        </header>
    );
}

export default AccountHeader;
